<p-card header="Customer Details">
    <p-toast></p-toast>
    <form [formGroup]="customerDetailsForm">

        <div class="flex justify-content-between">
            <div>
                <button pButton pRipple type="button" label="Update" class="p-button-sm " icon="bi bi-search"
                    (click)="updateCustomer(customerDetailsForm.value)"></button>
                <p-button label="Cancel" icon="pi pi-times" severity="danger" size="small" (click)="cancel()"
                    class="p-button-sm ml-2"></p-button>
            </div>

            <div>
                <p-button label="View" (click)="menu.toggle($event)" [raised]="true" severity="info" size="small" />
                <p-tieredMenu #menu [model]="items" [popup]="true" />
            </div>

        </div>

        <div class="formgrid grid">
            &nbsp;
            <div class="field col-12 flex">
                <div class="flex align-items-center">
                    <p-radioButton value="individual" inputId="customertype_ii" formControlName="type"
                        [ngClass]="{'ng-invalid ng-dirty': submitted && formControls.type.errors }"></p-radioButton>
                    <label for="customertype_ii" class="ml-2">Individual</label>
                </div>

                <div class="flex align-items-center ml-5">
                    <p-radioButton value="company" inputId="customertype_cc" formControlName="type"
                        [ngClass]="{'ng-invalid ng-dirty': submitted && formControls.type.errors }"></p-radioButton>
                    <label for="customertype_cc" class="ml-2">Company</label>
                </div>
                <div class="flex align-items-center ml-5">
                    <p-checkbox label="Active" formControlName="isActive" [binary]="true" value="true"></p-checkbox>
                </div>
                <div class="flex align-items-center ml-5">
                    <p-checkbox label="Ship To Customer" formControlName="IsShipToCustomer" [binary]="true"
                        value="true"></p-checkbox>
                </div>
            </div>
        </div>


        <div class="mainframe" style="display: flex; gap: 20px;">

            <!-- LEFT SIDE (FORM - 70%) -->
            <div class="mainView-primary" style="width: 70%; display: flex; flex-direction: column; gap: 15px;">

                <!-- ROW 1 -->
                <div style="display: flex; gap: 15px;">

                    <!-- Customer Code -->
                    <div class="field w-full form-field customer-code-field">
                        <label class="label-required">Customer Code</label>

                        <input pInputText placeholder="e.g 307" readonly formControlName="customerCode"
                            class="w-full p-inputtext-sm"
                            [ngClass]="{'ng-invalid ng-dirty': submitted && formControls.customerCode.errors }" />
                        <small *ngIf="submitted && formControls.customerCode.errors" id="name-error"
                            class="text-red-500">Required field.</small>
                    </div>

                    <!-- GST Treatment -->
                   <div class="field w-full form-field gst-treatment-wide">
                         <label class="label-required">GST Treatment</label>
                        <div>
                            <p-dropdown formControlName="gstTreatment" [options]="gstTreatmentList" optionLabel="name"
                                placeholder="Select GST Treatment" class="w-full" [ngClass]="{
                                    'ng-invalid ng-dirty':
                                    submitted && formControls.gstTreatment.errors
                                }">


                                <ng-template let-item pTemplate="item">
                                    {{item.code}} - {{item.name}}
                                </ng-template>

                                <ng-template let-item pTemplate="selectedItem">
                                    {{item?.code}} - {{item?.name}}
                                </ng-template>

                            </p-dropdown>
                        </div>
                    </div>

                </div>

                <!-- ROW 2 -->
                <div style="display: flex; gap: 15px;">

                    <!-- Customer Name -->
                    <div class="field w-full form-field">
                        <label class="label-required">Customer Name</label>
                        <input pInputText placeholder="e.g XYZ" formControlName="customerName"
                            class="w-full p-inputtext-sm" (keydown)="onKeydown($event)"
                            [ngClass]="{'ng-invalid ng-dirty': submitted && formControls.customerName.errors}" />
                    </div>

                    <!-- Customer Description -->
                    <div class="field w-full form-field">
                        <label>Customer Description</label>
                        <input pInputText placeholder="e.g ABC" formControlName="customerDescription"
                            class="w-full p-inputtext-sm" (keydown)="onKeydown($event)" />
                    </div>

                </div>

            </div>

            <!-- RIGHT SIDE (IMAGE - 30%) -->
            <div class="mainView-secondary"
                style="width: 30%; display:flex; flex-direction: column; align-items:center;">

                <input type="file" (change)="onFileSelected($event)" #fileInput hidden />

                <!-- Image Preview -->
                <div (click)="fileInput.click()" style="cursor:pointer;">
                    <img *ngIf="previewImage" [src]="previewImage" width="150" height="140"
                        style="border:2px solid #ccc; border-radius:10px; object-fit:cover;" />

                    <img *ngIf="!previewImage" src="./assets/upload-logo.jpg" width="120"
                        style="border:2px solid #ccc; border-radius:10px;" />
                </div>

                <!-- Delete -->
                <p-button *ngIf="previewImage" icon="pi pi-trash" severity="danger" class="mt-2"
                    (click)="deleteImage()">
                </p-button>

            </div>

        </div>


        <p-tabView>
            <p-tabPanel header="General Information">
                <!-- <div class="formgrid grid"> -->
                <div class="grid ">
                    <div class="col">
                        <div class="field text-left" formGroupName="address">
                            <label for="address">Address</label>
                            <input pInputText placeholder="Street Address" class="w-full p-inputtext-sm"
                                formControlName="addressLine1"
                                [ngClass]="{'ng-invalid ng-dirty': submitted && formControls.address.controls.addressLine1.errors}" />
                            <small *ngIf="submitted && formControls.address.controls.addressLine1.errors"
                                id="name-error" class="text-red-500">Required field.</small>
                            <input pInputText placeholder="Street Address 2" class="w-full p-inputtext-sm mt-1"
                                formControlName="addressLine2" />

                            <div class="flex mt-1">
                                <div>
                                    <input pInputText placeholder="City" class="w-full p-inputtext-sm"
                                        formControlName="city"
                                        [ngClass]="{'ng-invalid ng-dirty': submitted && formControls.address.controls.city.errors }" />
                                    <small *ngIf="submitted && formControls.address.controls.city.errors"
                                        id="name-error" class="text-red-500">Required field.</small>
                                </div>

                                
                                <!-- <div class=" ml-1">
                                   
                                        [forceSelection]="true" [readonly]="true" (onSelect)="setState($event)"
                                        formControlName="state" [suggestions]="filterStates"
                                        (completeMethod)="filterState($event)" field="stateName"
                                        [ngClass]="{'ng-invalid ng-dirty': submitted && formControls.address.controls.state.errors }"></p-autoComplete>
                                    <small *ngIf="submitted && formControls.address.controls.state.errors"
                                        id="name-error" class="text-red-500">Required field.</small>
                                </div> -->


                                 <div class=" ml-1">
                                    <!-- <input pInputText placeholder="State" class="w-full p-inputtext-sm" formControlName="state" [ngClass]="{'ng-invalid ng-dirty': submitted && formControls.address.controls.state.errors }"/> -->
                                    <p-autoComplete [dropdown]="true" placeholder="State" (onBlur)="checkState()"
                                        [forceSelection]="true" [readonly]="true" (onSelect)="setState($event)"
                                        formControlName="state" [suggestions]="filterStates"
                                        (completeMethod)="filterState($event)" field="stateName"
                                        [ngClass]="{'ng-invalid ng-dirty': submitted && formControls.address.controls.state.errors }">
                                        <ng-template let-state pTemplate="item">
                                           {{ state.stateCode  }} - {{ state.stateName }}
                                        </ng-template>
                                    </p-autoComplete>
                                    <small *ngIf="submitted && formControls.address.controls.state.errors"
                                        id="name-error" class="text-red-500">Required field.</small>
                                </div>

                                <div class=" ml-1">
                                    <input pInputText placeholder="Zip" class="w-full p-inputtext-sm"
                                        formControlName="zip"
                                        [ngClass]="{'ng-invalid ng-dirty': submitted && formControls.address.controls.zip.errors }" />
                                    <small *ngIf="submitted && formControls.address.controls.zip.errors" id="name-error"
                                        class="text-red-500">Required field.</small>
                                </div>

                            </div>
                            <input pInputText placeholder="Country" class="w-full p-inputtext-sm mt-1"
                                formControlName="country"
                                [ngClass]="{'ng-invalid ng-dirty': submitted && formControls.address.controls.country.errors}" />
                            <small *ngIf="submitted && formControls.address.controls.country.errors" id="name-error"
                                class="text-red-500">Required field.</small>
                        </div>
                        <!-- <div class="field text-left">
                        <label for="taxid">Tax ID</label>
                        <input pInputText placeholder="Tax ID" class="w-full p-inputtext-sm" formControlName="taxid"/>
                    </div> -->
                        <!-- <div class="field text-left">
                            <label for="tags">GSTIN</label>
                            <input pInputText placeholder="GSTIN" class="w-full p-inputtext-sm"
                                formControlName="GSTIN" />
                        </div> -->

                        <div class="field text-left">

                            <!-- Label -->
                            <label class="display" [ngClass]="{'label-required': isEinvoiceEnabled}">
                                GSTIN
                            </label>

                            <!-- Input -->
                            <input pInputText placeholder="GSTIN" formControlName="GSTIN" (keydown)="onKeydown($event)"
                                class="w-full p-inputtext-sm" [ngClass]="{
                                'ng-invalid ng-dirty':
                                isEinvoiceEnabled && submitted && formControls.GSTIN.errors
                                }" />

                            <!-- Invalid Format -->
                            <small *ngIf="isEinvoiceEnabled
                            && submitted
                            && formControls.GSTIN.errors?.['invalidGstin']" class="text-red-500">
                                Invalid GSTIN format.
                            </small>

                            <!-- State mismatch -->
                            <small *ngIf="isEinvoiceEnabled
        && submitted
        && customerDetailsForm.errors?.['stateMismatch']" class="text-red-500">
                                GSTIN state does not match selected state.
                            </small>

                        </div>

                    </div>
                    <div class="col ">
                        <div class="field text-left ">
                            <label for="phone">Phone</label>
                            <input pInputText placeholder="Phone" class="w-full p-inputtext-sm" formControlName="phone"
                                [ngClass]="{'ng-invalid ng-dirty': submitted && formControls.phone.errors }" />
                            <small *ngIf="submitted && formControls.phone.errors" id="name-error"
                                class="text-red-500">Required field.</small>
                        </div>
                        <div class="field text-left">
                            <label for="mobile">Mobile</label>
                            <input pInputText placeholder="Mobile" class="w-full p-inputtext-sm"
                                formControlName="mobile"
                                [ngClass]="{'ng-invalid ng-dirty': submitted && formControls.mobile.errors }" />
                            <small *ngIf="submitted && formControls.mobile.errors" id="name-error"
                                class="text-red-500">Required field.</small>
                        </div>
                        <div class="field text-left">
                            <label for="email">Email</label>
                            <input pInputText placeholder="Email" class="w-full p-inputtext-sm" formControlName="email"
                                [ngClass]="{'ng-invalid ng-dirty': submitted && formControls.email.errors }" />
                            <small *ngIf="submitted && formControls.email.errors" id="name-error"
                                class="text-red-500">Required field.</small>
                        </div>
                        <div class="field text-left">
                            <label for="website">Website</label>
                            <input pInputText placeholder="Website" class="w-full p-inputtext-sm"
                                formControlName="website" />
                        </div>
                        <div class="field text-left">
                            <label for="tags">Tags</label>
                            <input pInputText placeholder="Tags" class="w-full p-inputtext-sm" formControlName="tags" />
                        </div>
                    </div>
                </div>
                <!-- </div> -->
            </p-tabPanel>

            <p-tabPanel header="Contacts & Addresses">
                <app-contact-list *ngIf="customerId && customerId > 0" [customerId]="customerId"></app-contact-list>

            </p-tabPanel>

            <p-tabPanel header="Account Receivables">
                <div class="grid">
                    <div class="flex gap-4" style="width: 100%; flex-wrap: wrap;">
                        <div class="col" style="flex: 0 0 23%; min-width: 200px;">
                            <div class="field text-left">
                                <label for="termsCode">Payment Terms</label>
                                <div class="p-inputgroup p-lookup">
                                    <input pInputText class="w-full p-inputtext-sm" readonly (click)="getTermsCode()"
                                        formControlName="termsDescription" (keydown.enter)="focusNextInput($event)" />
                                    <button type="button" pButton pRipple severity="info" icon="pi pi-search"
                                        (click)="getTermsCode()"></button>
                                </div>
                            </div>

                            <div class="col" style="flex: 0 0 23%; min-width: 200px;">
                                <div class="field text-left">
                                    <label for="outstandingRec">Outstanding Receivables (₹)</label>
                                    <input pInputText class="w-full p-inputtext-sm" formControlName="outstandingRec"
                                        readonly [value]="formControls.outstandingRec.value | number:'1.2-2':'en-IN'" />
                                </div>
                            </div>

                        </div>

                        <div class="col" style="flex: 0 0 23%; min-width: 200px;">
                            <div class="field text-left">
                                <label for="glAccountCode">GL Account</label>
                                <div class="p-inputgroup p-lookup">
                                    <input pInputText class="w-full p-inputtext-sm" formControlName="glAccountCode"
                                        (keydown.enter)="focusNextInput($event)" />
                                    <button type="button" pButton pRipple severity="info" icon="pi pi-search"
                                        (click)="getGLAccount()"></button>
                                </div>

                                <div class="col" style="flex: 0 0 23%; min-width: 260px; margin-top: 10px;">
                                    <div class="field text-left">
                                        <label for="customerCredit">Customer Credit (₹)</label>
                                        <input pInputText class="w-full p-inputtext-sm text-right"
                                            [value]="formControls.customerCredit.value | number:'1.2-2':'en-IN'" readonly />
                                        <small class="text-muted">Advance / excess payment balance available to apply</small>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="col" style="flex: 0 0 23%; min-width: 200px;">
                            <div class="field text-left">
                                <label for="creditLimit">Credit Limit</label>
                                <input pInputText class="w-full p-inputtext-sm" formControlName="creditLimit"
                                    [readonly]="formControls.noCreditLimit.value"
                                    [ngClass]="{'ng-invalid ng-dirty': submitted && formControls.creditLimit.errors}" />
                            </div>

                            <div class="field text-left flex items-center mt-5">
                                <label for="noCreditCheck" class="mr-5">No Credit Check</label>
                                <div class="p-checkbox">
                                    <p-checkbox formControlName="noCreditCheck" [binary]="true"></p-checkbox>
                                </div>
                            </div>

                        </div>

                        <div class="col" style="flex: 0 0 23%; min-width: 200px;">
                            <div class="field text-left flex items-center mt-5">
                                <label for="noCreditLimit" class="mr-5">No Credit Limit</label>
                                <div class="p-checkbox">
                                    <p-checkbox formControlName="noCreditLimit" [binary]="true"
                                        (onChange)="onNoCreditLimitChange()"></p-checkbox>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </p-tabPanel>

            <p-tabPanel header="Recent Interactions">

                <div class="flex gap-2 align-items-center m-3">
                    <p-dropdown [options]="months" [(ngModel)]="selectedMonth" (onChange)="onMonthChange($event)"
                        placeholder="Select Month" [ngModelOptions]="{ standalone: true }" optionLabel="name"
                        optionValue="value">
                    </p-dropdown>

                    <p-dropdown [options]="years" [(ngModel)]="selectedYear" (onChange)="onYearChange($event)"
                        placeholder="Select Year" [ngModelOptions]="{ standalone: true }" optionLabel="name"
                        optionValue="value">
                    </p-dropdown>

                    <button pButton type="button" label="Filter" icon="pi pi-filter"
                        (click)="filterByMonthYear()"></button>

                    <div class="flex">
                        <div class="flex align-items-center">
                            <p-button icon="pi pi-refresh" size="small" (click)="refresh()" [rounded]="true"
                                severity="info"></p-button>
                        </div>
                    </div>
                </div>


                <p-table #dt1 [value]="RecentInteractionsData" [scrollable]="true" scrollHeight="300px"
                    styleClass="p-datatable-striped" responsiveLayout="scroll" class="w-full m-5"
                    styleClass="p-datatable-sm" [paginator]="true" [rows]="10" [selectionPageOnly]="true"
                    [globalFilterFields]="['productCode']"
                    currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                    [rowsPerPageOptions]="[10,15,20]" [totalRecords]="RecentInteractionsData.length">
                    <ng-template pTemplate="header">
                        <tr>
                            <!-- <th>
                    <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
                </th> -->
                            <th>Date / Time</th>
                            <th>Type</th>
                            <th>From</th>
                            <th>To</th>
                            <th>Subject</th>
                            <th>Description </th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-RecentInteractionsData>
                        <tr>
                            <!-- <td>
                    <p-tableCheckbox [value]="RecentInteractionsData"></p-tableCheckbox>
                </td> -->
                            <td>{{ RecentInteractionsData.sendDate | date: 'MMMM d, y h:mm a' }}</td>
                            <td>{{RecentInteractionsData.type}}</td>
                            <td>{{RecentInteractionsData.from}}</td>
                            <td>{{RecentInteractionsData.to}}</td>
                            <td>{{RecentInteractionsData.subject}}</td>
                            <td>{{RecentInteractionsData.description}}</td>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="emptymessage">
                        <tr>
                            <td colspan="8">No Records found.</td>
                        </tr>
                    </ng-template>

                </p-table>

            </p-tabPanel>

        </p-tabView>
    </form>
</p-card>